import { LocalStorageService } from '../../shared/services/local-storage.service';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {

  private deviceIdKey = 'device_id';

  constructor(private localStorage: LocalStorageService) {
  }

  async getDeviceId(): Promise<string> {
    let deviceId = this.localStorage.getItem(this.deviceIdKey);
    if (!deviceId) {
      const components = [
        navigator.userAgent,
        navigator.platform,
        navigator.vendor,
        (navigator.language || 'unknown').split('-')[0].toUpperCase(), // tylko "pl"
        navigator.hardwareConcurrency || 'unknown',
        0,
        screen.width + 'x' + screen.height,
        screen.colorDepth,
        window.devicePixelRatio,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      ].join('||');

      deviceId = await this.hashWithSalt(components);
      this.localStorage.setItem(this.deviceIdKey, deviceId);
    }

    return deviceId as string;
  }

  private async hashWithSalt(data: string): Promise<string> {
    const msgBuffer = new TextEncoder().encode(data);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }
}

